import React, { useMemo, useRef } from 'react';
import { useAgGridCommon } from 'common/table/agGrid/AgGridCommon';
import { AgGridReact } from 'ag-grid-react';
import { mergeGridOpts } from 'utils/agGrid/options';

import clearingAccountsOpts from '../options';
import useOnCellClick from '../useOnCellClick';
import useContext from '../useClearingAccountsContext';
import useDatasource from './useDatasource';
import useColumnDefs from './useColumnDefs';

const opts = mergeGridOpts(clearingAccountsOpts, {
  blockLoadDebounceMillis: 1500,
});

export const LEDGER_ACCOUNTS_GRID_NAME = 'ledgerAccounts';
const LEDGER_ACCOUNTS_GRID_VERSION = 1;

const LedgerAccountsGrid = () => {
  const gridRef = useRef<AgGridReact>(null);

  const isUpdate = useMemo(() => {
    const parsedUrl = new URL(window.location.href);
    return parsedUrl.pathname.includes('update_member');
  }, []);

  const { gridVisible, initialGridSettings, onStateUpdated } = useAgGridCommon({
    gridName: LEDGER_ACCOUNTS_GRID_NAME,
    version: LEDGER_ACCOUNTS_GRID_VERSION,
  });

  const onCellClicked = useOnCellClick();
  const context = useContext();
  const columnDefs = useColumnDefs();
  const datasource = useDatasource({ isUpdate });

  return (
    <div className="ag-theme-quartz">
      {gridVisible ? (
        <AgGridReact
          ref={gridRef}
          columnDefs={columnDefs}
          gridOptions={opts}
          onStateUpdated={onStateUpdated}
          initialState={initialGridSettings}
          rowModelType="serverSide"
          serverSideDatasource={datasource}
          context={context}
          onCellClicked={onCellClicked}
        />
      ) : null}
    </div>
  );
};

export default LedgerAccountsGrid;
